import {Page} from 'utils/page-utils';
import CMSUtils from 'utils/cms';
import {PRISMIC_CUSTOM_TYPE} from 'utils/prismic-types';

const getInitialState = async ({
    cookies,
    state,
    route: {
        location: {search},
    },
}) => {
    // get prismic data for the Download the App component
    const prismicData = await CMSUtils.getPageData({
        cookies,
        slug: 'web-confirmation',
        customType: PRISMIC_CUSTOM_TYPE.CONFIRMATION,
    });
    // get order ID from URL
    const urlParams = new URLSearchParams(search);
    const orderId = urlParams.get('id');
    const accessKey = urlParams.get('key');

    state.searchRequest.pageType = Page.CONFIRMATION;

    if (!orderId) {
        // eslint-disable-next-line no-throw-literal
        throw {
            status: 404,
            message: `This confirmation page does not exist or has incomplete data`,
        };
    } else {
        return {
            ...state,
            page: {
                cmsData: prismicData,
                orderId,
                accessKey,
            },
        };
    }
};

export default getInitialState;
